export default "__VITE_ASSET__BDMB00tu__"